
// BEWARE! This is relative to the UI located at ".../plugin/auth2/"!
// API calls will break if you move UI pages within subdirectories!
// It was made on purpose using relative URLs to be "proxy-friendly"
import {$t} from "./translations";

export const API_URL = '../de.elo.ix.plugin.rest/auth2'

export const buefyConfig = {
    defaultIconPack: 'e-icon', // EAUTH2-33
    defaultCompatFallthrough: false // EAUTH2-216: accessibilty issue, see https://github.com/buefy/buefy/issues/4159
}

export function isEmpty(obj) :boolean {
    return !obj || Object.keys(obj).length === 0
}

export function isInsideIFrame() :boolean {
    return (window.top !== window.self)
}

export async function fetchJson(url :string) :Promise<any> {
    try {
        const req = await fetch(url)
        if (!req.ok)
            throw `Unexpected response status: ${req.status}`

        const json = await req.json()
        console.debug(json)

        return json
    }
    catch(e) {
        console.error(e)
        alert(`Failed to fetch ${url}`)
        throw e
    }
}



// EAUTH2-87: keepalive function to prevent session expiration, both before and after login
// Before login, the "without ix" session must be kept to remember the client's original call parameters
// After login, it is to keep the "with ix" session alive
export async function keepalive(ixSession) {
    const res = await fetch(`${API_URL}/${ixSession ? 'keepalive' : 'status'}`)
    if (!res.ok) {
        alert("Connection lost. Please login again.")
        window.location.href = "./sign-in"
    }
    else {
        window.setTimeout(keepalive, 60000, ixSession)
    }
}

export function getTimezone() :string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
}


// EAUTH2-232: avoid /sign-in or /popup-launcher page to appear when clicking on the browser's back button
// Note that moving in the browser history do not send requests at all by default
// Instead, the state is restored from the browser's "bfcache" (Back-Forward Cache)
// Therefore, we need to explicitly check if the page is restored from this bfcache
// and reload the page, which will result in a redirect back to the client.
export function reloadPageIfCached() {
    window.addEventListener("pageshow", function (event) {
        console.debug(`pageshow event triggered, persisted: ${event.persisted}`);
        if (event.persisted) {
            console.log("Page restored from bfcache");
            window.location.reload();
        }
    });
}

// EAUTH2-261: nicer error messages
// EAUTH2-298: forward IX error messages if possible
async function parseErrorMessage(res :Response, defaultMessage :string) :Promise<string> {
    try {
        const json = await res.json()
        if(json.isLocalized && json.message)
            return json.message
    }
    catch (e) {
        console.warn('Unable to parse error message from response', e)
    }
    return defaultMessage
}

// EAUTH2-298: homogenize errors and messages for credential-related operations
// This forwards the localized IX error or a generic default error
// that fits both login and password change errors.
export async function parseEloCredentialsError(res :Response) {

    if (res.status === 401) // not authenticated, wrong credentials or admin mode maintenance
        return parseErrorMessage(res, $t('error_wrong_credentials'));
    else if (res.status === 403) // blocked, globally disabled or missing rights
        return parseErrorMessage(res, $t('error_password_forbidden'));
    else if (res.status === 409) // fails because of password rules or IX refusal
        return parseErrorMessage(res, $t('error_new_password_rejected'));
    else {
        // EAUTH2-261: nicer errors also for unexpected ones
        return parseErrorMessage(res, $t('error_unexpected'));
    }
}
